import { component } from "picoapp";

export const contentCardMarquee = component((node: HTMLElement) => {
  const desktopContentCardElements = node.querySelectorAll<HTMLElement>(
    ".desktop-marquee [data-tbsp-component='contentCard']"
  );

  const desktopMarquees =
    node.querySelectorAll<HTMLElement>(".desktop-marquee");

  const handleContentCardHoverOn = () => {
    desktopMarquees.forEach((desktopMarquee) => {
      desktopMarquee.style.animationPlayState = "paused";
    });
  };

  const handleContentCardHoverOff = () => {
    desktopMarquees.forEach((desktopMarquee) => {
      desktopMarquee.style.animationPlayState = null;
    });
  };

  desktopContentCardElements.forEach((card) => {
    card.addEventListener("mouseenter", handleContentCardHoverOn);
    card.addEventListener("mouseleave", handleContentCardHoverOff);
  });

  return () => {
    desktopContentCardElements.forEach((card) => {
      card.removeEventListener("mouseenter", handleContentCardHoverOn);
      card.removeEventListener("mouseleave", handleContentCardHoverOff);
    });
  };
});
